import { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.scss";

function ProcessusPhone() {

   

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>Notre processus</div>

                <div className={styles.box}>


                    <div className={styles.hr}></div>
                    <div className={styles.images}>
                        <img src="/images/support1.png" alt='img' />
                        <img src="/images/specifications.png" alt='img' />
                        <img src="/images/design.png" alt='img' />
                        <img src="/images/code.png" alt='img' />
                        <img src="/images/integration.png" alt='img' />
                        <img src="/images/support2.png" alt='img' />
                    </div>



                    <div className={styles.bubbles}>
                        <div className={styles.speech_bubble}>
                            <text>
                                Assistances
                            </text>

                        </div>
                        <div className={styles.speech_bubble}>
                            <text>
                                Cahier des charges
                            </text>
                        </div>
                        <div className={styles.speech_bubble}>
                            <text>
                                Design
                            </text>
                        </div>
                        <div className={styles.speech_bubble}>
                            <text>
                                Développement
                            </text>
                        </div>
                        <div className={styles.speech_bubble}>
                            <text>
                                Intégration
                            </text>
                        </div>
                        <div className={styles.speech_bubble}>
                            <text>
                                Accompagnement
                            </text>
                        </div>
                    </div>
                </div>
                <div className={styles.link}>

                    <ul>
                        <li>
                        <Link to="/processus">
                            <a className={styles.animated_arrow} href="#">
                                <span className={styles.the_arrow + " " + styles.left}>
                                    <span className={styles.shaft}></span>
                                </span>
                                <span className={styles.main}>
                                    <span className={styles.text}>
                                        EN SAVOIR PLUS
                                    </span>
                                    <span className={styles.the_arrow + " " + styles.right}>
                                        <span className={styles.shaft}></span>
                                    </span>
                                </span>
                            </a>
                            </Link>
                        </li>
                    </ul>

                </div>
            </section>
        </>
    )
}

export default ProcessusPhone;